import { fetchApi } from '../../../../utils/fetchApi';
import { UpdateUserHeaderImageProps, UpdateUserHeaderOutput } from '../types';
import { getConfig } from '../../../config/envConfig';
import { isFedRamp } from '../../../config/env';
import buildHeaderImageUrl from './buildHeaderImageUrl';

const updateHeaderImageWithUserPrefCall = async ({
  userId,
  fields,
}: UpdateUserHeaderImageProps): Promise<UpdateUserHeaderOutput | undefined> => {
  // MediaApi is disabled in FedRamp
  if (isFedRamp()) {
    return undefined;
  }
  const { stargateRoot } = getConfig();
  const updateUserHeaderImageUrl = `${stargateRoot}/api/user-image/self/header-image`;
  await fetchApi(updateUserHeaderImageUrl, {
    method: 'PUT',
    body: JSON.stringify({
      headerImageId: fields.headerImageId,
    }),
  });

  const headerImageUrl = await buildHeaderImageUrl(userId);
  return {
    data: {
      User: {
        id: userId,
        headerImageUrl,
      },
    },
  };
};

export default updateHeaderImageWithUserPrefCall;
